import { pageable } from 'apis/core/commonSchema';
import { listingSearchParam } from 'apis/handler/listing/listingSchema';
import type { mainListingInfo } from 'apis/handler/listing/listingSchema';
import type { AxiosError, AxiosRequestConfig } from 'axios';
import { apiClient } from 'shared/api';

import type {
  ListingResponse,
  MapPointsParam,
  MapPointsResponse,
  MapPreviewResponse,
  SameTypeRoom,
} from '../model/dto';

export const getListing = async (
  searchParam: listingSearchParam,
  pageableParam: pageable,
): Promise<ListingResponse> => {
  const { agentCommentTypes, ...restSearchParam } = searchParam;

  const commentQuery = agentCommentTypes?.map((c) => `agentCommentTypes=${c}`).join('&');

  const endpoint = commentQuery ? `/listing?${commentQuery}` : '/listing';

  const { data } = await apiClient.get(endpoint, {
    ...restSearchParam,
    ...pageableParam,
  });

  return data.result;
};

export const getMapPoints = async (params: MapPointsParam): Promise<MapPointsResponse> => {
  const { agentCommentTypes, ...restParams } = params;

  const commentQuery = agentCommentTypes?.map((c) => `agentCommentTypes=${c}`).join('&');

  const endpoint = commentQuery ? `/listing/map-points?${commentQuery}` : '/listing/map-points';

  const { data } = await apiClient.get(endpoint, restParams as Record<string, string | number | boolean | undefined>);

  return data.result;
};

export const getListingMapPreview = async (id: number): Promise<MapPreviewResponse> => {
  const { data } = await apiClient.get(`/listing/${id}/map-preview`);

  return data.result;
};

export const getSimilarListings = async (id: string): Promise<mainListingInfo[]> => {
  const { data } = await apiClient.get(`/listing/${id}/similar`);

  return data.result;
};

export const getSameTypeRooms = async (id: string): Promise<SameTypeRoom[]> => {
  // 로그인과 무관한 공개 API라 401/403에 토큰 재발급을 하지 않는다(_retry). 재발급이 실패하면 손님이 홈으로 튕긴다.
  // 서버에 이 API가 아직 없으면(403/404) 칸만 숨긴다 — 웹이 백엔드보다 먼저 배포돼도 상세 페이지가 깨지지 않게.
  const options: AxiosRequestConfig & { _retry: boolean } = { _retry: true };
  try {
    const { data } = await apiClient.get(`/listing/${id}/same-type-rooms`, undefined, options);
    return data.result ?? [];
  } catch (error) {
    const status = (error as AxiosError).response?.status;
    if (status === 403 || status === 404) return [];
    throw error;
  }
};
